<script lang="ts">
    import Footer from "./footer/Footer.svelte";
    import Head from "./header/Head.svelte";
    import Navbar from "./header/Navbar.svelte";
    import { appManager } from "./AppManagerStore";
    import AngleLeft from "./svg/shapes/AngleLeft.svelte";
    import { _ } from "svelte-i18n";
    import app from "./main";
</script>

<svelte:head>
    <title>ANYWAYS | {$_("notfound.pagetitle")}</title>
</svelte:head>

<section class="section-border border-primary">
    <div class="container d-flex flex-column">
        <div
            class="row align-items-center justify-content-center gx-0 min-vh-100">
            <div class="col-12 col-md-5 col-lg-4 py-8 py-md-11">
                <h1 class="display-3 fw-bold text-center">{$_("notfound.title")}</h1>

                <p class="mb-5 text-center text-muted">
                    {$_("notfound.message")}
                </p>

                <div class="text-center">
                    <a class="btn btn-primary" href="{$appManager.PublicUrl}">{$_("notfound.backsafe")}</a>
                </div>
            </div>
        </div>
    </div>
</section>
